export default __webpack_public_path__ + "static/Hue-5ff3d8beac8cee2f9d295c22d15a00e4.png";